import { api } from "api/root";
import { CancelTokenSource } from "axios";
import { Dispatch } from "react";
import { IMapViewPointsResponse, IMapSearchRequest, IMapSearchResponse } from "./types";



export const getMapViewFilteredPoints = async (data: {
    workspaceId: string, 
    // mapOptions: TreeViewDataItem, 
    // filterOptions: IFilterOptions, 
    // categorizeOptions: ICategorizeOptions, 
    ApplyFilters?: boolean
    leftBottomCorner?: {
        latitude: number,
        longitude: number
    },
    rightTopCorner?: {
        latitude: number,
        longitude: number
    },
    source?: CancelTokenSource
}, thunkAPI: unknown) => {
    try {
        const {workspaceId, leftBottomCorner, rightTopCorner, ApplyFilters, source } = data;
        // const request = createRequestModel(mapOptions, filterOptions, categorizeOptions)
        const response = await api.get<string, {data: IMapViewPointsResponse}>(`/Workspace/${workspaceId}/MapView/Data`, {
            params: { 
                'LeftBottom.Latitude': leftBottomCorner?.latitude, 
                'LeftBottom.Longitude':leftBottomCorner?.longitude, 
                'RightTop.Latitude': rightTopCorner?.latitude, 
                'RightTop.Longitude': rightTopCorner?.longitude,
                ApplyFilters: ApplyFilters 
            },
            cancelToken: source?.token
        });   

        return {mapViewData: response.data}
    } catch (e: unknown) {
        const validationMessage = e as { message: string, response: { data: { status: string, title: string } } };
        const thunkRejectError = thunkAPI as { rejectWithValue: (message: string) => string, dispatch: Dispatch<unknown> }
        return thunkRejectError.rejectWithValue(validationMessage.message);
    }
}

export const getAnalogueMapViewFilteredPoints = async (data: {
    plotId: string, 
    // mapOptions: TreeViewDataItem, 
    // filterOptions: IFilterOptions, 
    // categorizeOptions: ICategorizeOptions, 
    ApplyFilters?: boolean
    leftBottomCorner?: {
        latitude: number,
        longitude: number
    },
    rightTopCorner?: {
        latitude: number,
        longitude: number
    },
    source?: CancelTokenSource
}, thunkAPI: unknown) => {
    try {
        const {plotId, leftBottomCorner, rightTopCorner, ApplyFilters, source } = data;
        // const request = createRequestModel(mapOptions, filterOptions, categorizeOptions)
        const response = await api.get<string, {data: IMapViewPointsResponse}>(`/Workspace/${plotId}/AnalogueMapView/Data`, {
            params: { 
                'LeftBottom.Latitude': leftBottomCorner?.latitude, 
                'LeftBottom.Longitude':leftBottomCorner?.longitude, 
                'RightTop.Latitude': rightTopCorner?.latitude, 
                'RightTop.Longitude': rightTopCorner?.longitude,
                ApplyFilters: ApplyFilters 
            },
            cancelToken: source?.token
        });   

        return {mapViewData: response.data}
    } catch (e: unknown) {
        const validationMessage = e as { message: string, response: { data: { status: string, title: string } } };
        const thunkRejectError = thunkAPI as { rejectWithValue: (message: string) => string, dispatch: Dispatch<unknown> }
        return thunkRejectError.rejectWithValue(validationMessage.message);
    }
}

// New search service function
export const searchMapRecords = async (data: IMapSearchRequest, source?: CancelTokenSource) => {
    try {
        const { workspaceId, searchText, pageSize = 20, offset = 0 } = data;
        
        const response = await api.get<string, { data: IMapSearchResponse }>(`/Workspace/${workspaceId}/MapView/Search`, {
            params: {
                searchText,
                pageSize,
                offset
            },
            cancelToken: source?.token
        });

        return response.data;
    } catch (e: unknown) {
        console.error('Map search error:', e);
        throw e;
    }
}

// Function to check if map search feature is enabled
export const checkMapSearchFeatureFlag = async (workspaceId: string, source?: CancelTokenSource) => {
    try {
        const response = await api.get<string, { data: { isEnabled: boolean } }>(`/Workspace/${workspaceId}/MapView/Search/FeatureFlag`, {
            cancelToken: source?.token
        });

        return response.data.isEnabled;
    } catch (e: unknown) {
        return false; // Default to disabled if error occurs
    }
}